import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLaneLifecycleSubscriptionVariables = Types.Exact<{
  laneId: Types.Scalars['bigint']['input'];
}>;


export type GetLaneLifecycleSubscription = { __typename?: 'subscription_root', lanes_by_pk?: { __typename?: 'lanes', id: number, status?: string | null, updatedat?: string | null, distance_miles?: number | null, tolls?: number | null, duration_sec?: number | null, enriched_at?: string | null, route_polyline?: string | null } | null };


export const GetLaneLifecycleDocument = gql`
    subscription GetLaneLifecycle($laneId: bigint!) {
  lanes_by_pk(id: $laneId) {
    id
    status
    updatedat
    distance_miles
    tolls
    duration_sec
    enriched_at
    route_polyline
  }
}
    `;

/**
 * __useGetLaneLifecycleSubscription__
 *
 * To run a query within a React component, call `useGetLaneLifecycleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLaneLifecycleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaneLifecycleSubscription({
 *   variables: {
 *      laneId: // value for 'laneId'
 *   },
 * });
 */
export function useGetLaneLifecycleSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetLaneLifecycleSubscription, GetLaneLifecycleSubscriptionVariables> & ({ variables: GetLaneLifecycleSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLaneLifecycleSubscription, GetLaneLifecycleSubscriptionVariables>(GetLaneLifecycleDocument, options);
      }
export type GetLaneLifecycleSubscriptionHookResult = ReturnType<typeof useGetLaneLifecycleSubscription>;
export type GetLaneLifecycleSubscriptionResult = Apollo.SubscriptionResult<GetLaneLifecycleSubscription>;